<template>
  <label v-if="label" class="form-label" :for="'option-' + id">
    {{ label }}
  </label>
  <select
    :id="'option-' + id"
    v-if="options.length"
    class="form-select pr-8"
    v-model="form.option"
    :disabled="disabled || form.processing"
    @change="submit"
  >
    <option
      v-for="option in options"
      :value="option.id"
      :key="option.id"
    >
      {{ option.name }}
    </option>
  </select>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

<script setup>
import { useForm } from '@inertiajs/inertia-vue3/dist';
import { computed, watchEffect } from 'vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  options: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    required: true,
  },
  label: {
    type: String,
    required: false,
  },
});

const form = useForm({
  option: null,
});

const option = computed(() =>
  props.options.find(option => option.selected) ?? null
);

function submit() {
  form.put(route('cart.lines.update-option', [props.id]), {
    preserveScroll: true
  });
}

watchEffect(() => {
  form.option = option.value?.id;
});

</script>
